import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import LeftMenuSidebar from "../../../unicomponents/LeftMenuSidebar";
import TextLengthManagement from "./components/TextLengthManagement";
import SchoolInformation from "./components/SchoolInformation";
import StudentInfoFieldSettings from "./components/StudentInfoFieldSettings";

export default function ExtraSettings() {
  const { t } = useTranslation();

  const [activeMenu, setActiveMenu] = useState({
    menu_name: "school_information",
    menu_id: "school_information",
  });

  const menuData = [
    {
      item_name: "school_information",
      item_label:
        t("admin.extraSettings.schoolInformation") || "학교 정보 관리",
    },
    {
      item_name: "text_length_management",
      item_label:
        t("admin.extraSettings.textLengthManagement") || "글자수 제한 설정",
    },
    {
      item_name: "student_info_field_settings",
      item_label: "학생 기본정보 필드 설정",
    },
  ];

  return (
    <div className="basicWidth">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-2">
            <LeftMenuSidebar
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              menuData={menuData}
              itemName="item_name"
              itemLabel="item_label"
            />
          </div>
          <div className="col-12 col-md-10">
            {activeMenu.menu_name === "text_length_management" && (
              <TextLengthManagement />
            )}
            {activeMenu.menu_name === "school_information" && (
              <SchoolInformation />
            )}
            {activeMenu.menu_name === "student_info_field_settings" && (
              <StudentInfoFieldSettings />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
